// extracted by mini-css-extract-plugin
module.exports = {"TDA":"TDA--2WyrU","activeBox":"activeBox--2vaiO"};